// extracted by mini-css-extract-plugin
export var checkbox = "_5a-0";
export var circle = "_5a-3";
export var horizontalContainer = "_5a-7";
export var sm = "_5a-5";
export var switch0 = "_5a-2";
export var switchDisabled = "_5a-8";
export var switchEnabled = "_5a-1";
export var textSwitchContainer = "_5a-9";
export var textSwitchOption = "_5a-a";
export var textSwitchOptionSelected = "_5a-b";
export var verticalContainer = "_5a-6";
export var xs = "_5a-4";